module.exports = __webpack_public_path__ + "img/24add.cd90cade.svg";